import type { Cache } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { RefCodeQuery} from '@/graphql/generated/graphql';
import { RefCodeDocument } from '@/graphql/generated/graphql';

export const updateSchoolCache = (cache: Cache, schoolID: number) => {
  invalidateQuery('schoolPrimaryRefCode', cache, { schoolID });
  invalidateQuery('schools', cache);
  invalidateQuery(['refCodeTerms', 'refCodeTerm'], cache);
};

const updateImplementationsCache = (cache: Cache, refCodeID: number) => {
  const refCode = cache.readQuery<RefCodeQuery>({
    query: RefCodeDocument, variables: { id: refCodeID },
  });
  if (refCode?.refCode?.school_id) {
    updateSchoolCache(cache, refCode.refCode.school_id);
  }
};

export default updateImplementationsCache;
